import { lazy, Suspense } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

// Lazy load heavy map components
const LazyLeafletTrackingMap = lazy(() => 
  import('@/components/LeafletTrackingMap').then(module => ({
    default: module.LeafletTrackingMap
  }))
);

const LazyRestaurantsMap = lazy(() => 
  import('@/components/RestaurantsMap').then(module => ({
    default: module.RestaurantsMap
  }))
);

const LazyRoutePreviewMap = lazy(() => 
  import('@/components/RoutePreviewMap').then(module => ({
    default: module.RoutePreviewMap
  }))
);

const LazyMagasMap = lazy(() => 
  import('@/components/MagasMap').then(module => ({
    default: module.MagasMap
  }))
);

// Map loading skeleton
const MapSkeleton = ({ className = '' }: { className?: string }) => (
  <div className={`relative overflow-hidden rounded-xl ${className}`}>
    <Skeleton className="w-full h-full min-h-[200px]" />
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="animate-pulse text-muted-foreground text-sm">
        Загрузка карты...
      </div>
    </div>
  </div>
);

// Re-export lazy components for direct use with Suspense
export { LazyLeafletTrackingMap, LazyRestaurantsMap, LazyRoutePreviewMap, LazyMagasMap };

// Export skeleton for custom usage
export { MapSkeleton };
